import React, { useEffect, useRef, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import { AddNewMessage } from './AddNewMessage/AddNewMessage';
import { DragIcon } from '../../../shared/IconsComponent/icons';
import TextEditor from '../../../../shared-components/TextEditor';
import SuperSearchMultipleServer from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer';
import { enumUtil } from '../../../../utils/Enum';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest';
import isNull from '../../../../utils/NullChecking';
import SuperSearchMultipleClient from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import { useSelector } from 'react-redux';
import DeleteConfirmatiom from '../../../General/DeleteConfirmation';
import Loader from '../../../shared/Loader/Loader';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { saveAs } from "file-saver";
import { convertTo24Hour } from '../../../../utils/Constants';
import FileViewer from '../../../shared/FileViewer/FileViewer';
import { FindFirstChild } from '../../../../utils/FindMenuOption';

const PatientMessages = () => {

  const API_URL_GENERAL = enumUtil.controller.General
  const API_URL_Patient = enumUtil.controller.Patient
  const API_URL_Wasabi_Download = enumUtil.controller.Wasabi_Download;
  const API_URL_PatientMessages = enumUtil.controller.PatientMessage
  let patientRecord = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
  let PatientName = patientRecord?.data?.name;
  let PatientIDR = patientRecord?.data?.id;
  const fileInputRef = useRef();
  let IsEditAllowed = FindFirstChild('Patient', 'Messages')?.IsAdd
  let IsDeleteAllowed = FindFirstChild('Patient', 'Messages')?.IsDeleted

  let Message_Modal = {
    "FilePath": "",
    "FileName": ""
  }

  const Description_Modal = {
    Message: "",
  }

  let Search_Data = {
    search: "",
    Type: "",
  }

  let DropdownData = [
    { value: 'Read', display: 'Read' },
    { value: 'Unread', display: 'Unread' },
    // { value: 'Archived', display: 'Archived' },
  ]
  const [MessageSubject, setMessageSubject] = useState('')
  const [mainMessageModal, setMainMessageModal] = useState(Message_Modal);
  const [messageDescriptionModal, setMessageDescriptionModal] = useState(Description_Modal);
  const [searchParam, setSearchParam] = useState(Search_Data);
  const [isLoading, setIsLoading] = useState(false);
  const [NewMessageOpen, setNewMessageOpen] = useState(false);
  const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);
  const [patientValue, setPateintValue] = useState([]);
  const [PatientMessagesData, setPatientMessagesData] = useState([]);
  const [NonArchivedMessagesData, setNonArchivedMessages] = useState([]);
  const [ArchivedMessagesData, setArchivedMessages] = useState([]);
  const [ArchivedSelectedMessages, setArchivedSelectedMessages] = useState([]);
  const [NonArchivedSelectedMessages, setNonArchivedSelectedMessages] = useState([]);
  const [showArchived, setShowArchived] = useState(false);
  const [IsMessageSelectable, setIsMessageSelectable] = useState(false);
  const [isDeleteMessage, setIsDeleteMessage] = useState(false);
  const [DeleteMessageID, setDeleteMessageID] = useState(null);
  const [DeleteModal, setDeleteModal] = useState({
    "TableName": enumUtil.enumAPITableName.PatientMessage,
    "DeleteData": {
      "PatientMessageID": "",
    }
  });
  const [SelectedMessages, setSelectedMessages] = useState([]);
  const [PatientMessageThread, setPatientMessageThread] = useState([]);
  const [FileInput, setFileInput] = useState('');
  const [FileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [ThreadMessageID, setThreadMessageID] = useState(0);
  const [PatientMessageID, setPatientMessageID] = useState(0);
  const [SubjectEditable, setSubjectEditable] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [FilePreview, setFilePreview] = useState(null);
  const [FilePreviewType, setFilePreviewType] = useState(null);
  const [PreviewModalActive, setPreviewModalActive] = useState(false);

  const getRelativeDate = (inputDateStr, timeStr) => {
    // Parse the input date (MM/DD/YYYY format)

    const inputParts = inputDateStr.split('/');
    const inputDate = new Date(inputParts[2], inputParts[0] - 1, inputParts[1]);

    // Get current date
    const today = new Date();

    // Reset both dates to midnight for accurate day comparison
    const inputDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Calculate difference in days
    const diffTime = todayDay - inputDay;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHrs = Math.floor(diffTime / (1000 * 60 * 60));
    // console.log("diffHrs", diffHrs, "diffTime", diffTime, "diffDays", diffDays, '_', todayDay, '_', inputDay, "_", inputDate)
    // Return appropriate string
    if (diffDays === 0) {

      return timeStr;
    } else if (diffDays === 1) {
      return "Yesterday";
    } else if (diffDays > 1) {
      return `${diffDays} days ago`;
    } else if (diffDays === -1) {
      return "Tomorrow";
    } else if (diffDays < 0) {
      return `In ${Math.abs(diffDays)} days`;
    }

    return inputDateStr; // fallback
  }

  const getPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  const handleMUltiSelectedData = (selectedDataArray, type, name) => {

    let modal = { ...searchParam };
    if (type === 'server' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);
      modal[name] = displayValues.join(', ');
    } else if (type === 'client' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);
      let joinvlues = valueValues.join(', ');
      modal[name] = valueValues.join(', ');
    }
    else {
      modal[name] = '';
    }
    setSearchParam(modal);
    return selectedDataArray;
  }

  const LoadData = (searchParam) => {

    setIsLoading(true);
    ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
      'ID': PatientIDR,
      "TableName": enumUtil.enumAPITableName.PatientMessage,
      "SearchCriteria": searchParam,
    })
      .then((response) => {
        let rowsData = response?.Rows ?? []
        rowsData = rowsData?.map((item) => {
          return {
            ...item,
            isSelected: false,
          }
        })
        let archivedData = rowsData?.filter((item) => item?.IsArcheive === 'true');
        let nonArchivedData = rowsData?.filter((item) => item?.IsArcheive === 'false');

        setIsLoading(false);

        setPatientMessagesData(rowsData);
        setArchivedMessages(archivedData);
        setNonArchivedMessages(nonArchivedData);
        if (!showArchived && nonArchivedData?.length > 0) {
          let firstMessage = nonArchivedData[0]?.PatientMessageID;
          handleOpenThread(firstMessage);
        } else if (showArchived && archivedData?.length > 0) {
          let firstMessage = archivedData[0]?.PatientMessageID;
          handleOpenThread(firstMessage);
        } else {
          handleMessageSelectable(false);
          setPatientMessageThread([])
          setSelectedItem(null);
          setSelectedMessages([]);
        }

      }).catch((error) => {
        setPatientMessagesData([])
        setPatientMessageThread([])
        setArchivedMessages([]);
        setNonArchivedMessages([]);
        setSelectedItem(null);
        setSelectedMessages([]);
        handleMessageSelectable(false);
        setIsLoading(false);
      })
    // }
  }

  const clearFilter = () => {
    setSearchParam(Search_Data);
    setReloadSuperSearchPatient(!reloadSuperSearchPatient);
  }

  const SearchOnEnter = async (e) => {
    if (e.key === "Enter") {
      SearchByParam(searchParam);
    }
  }

  const SearchByParam = () => {
    if (!isNull(searchParam)) {
      LoadData(searchParam)
    } else {
      LoadData()
    }
  }

  const handleArchivedMessage = (messageIDs, archieved) => {

    if (messageIDs instanceof Array) {
      messageIDs = messageIDs.join(', ')
    }

    const saveModal = {
      "ID": "1",
      "TableName": enumUtil.enumAPITableName.PatientMessage,
      "Data": {
        "IsArcheive": archieved + "",
        "PatientMessageID": messageIDs,
      }
    }

    setIsLoading(true)
    ServerRequestProtected(API_URL_GENERAL + '/SaveSingleRecord', 'post', saveModal)
      .then((response) => {
        setIsLoading(false);
        setArchivedSelectedMessages([]);
        setNonArchivedSelectedMessages([]);
        LoadData(searchParam);
      }).catch((error) => {
        setIsLoading(false);
      })
  }

  const handleDeleteMessage = (messageIDs, deleteFrom) => {
    if (IsDeleteAllowed) {
      if (messageIDs instanceof Array) {
        messageIDs = messageIDs.join(', ');
      }
      const saveModal = {
        "TableName": enumUtil.enumAPITableName.PatientMessage,
        "DeleteData": {
          "PatientMessageID": messageIDs,
        }
      }
      handleDeleteMessages(messageIDs, saveModal)
      // setIsLoading(true);
      // ServerRequestProtected(API_URL_GENERAL + '/DeleteSingleRecord', 'post', saveModal)
      //   .then((response) => {
      //     setIsLoading(false);
      //     LoadData(searchParam);
      //   }).catch((error) => {
      //     setIsLoading(false);
      //   })
    }

  }

  const handleShowArchivedMessage = () => {
    setShowArchived(!showArchived);
  }

  const handleSelectedMessage = (messageID, index, type) => {

    if (type === 'Archived') {

      let modal = [...ArchivedMessagesData];
      const isMessageExist = ArchivedSelectedMessages?.some((PatientMessageID) => PatientMessageID == messageID);

      if (isMessageExist) {

        modal[index]['isSelected'] = false;
        let filteredData = ArchivedSelectedMessages?.filter((PatientMessageID) => PatientMessageID != messageID);
        setArchivedSelectedMessages(filteredData);

      } else if (!isMessageExist) {

        modal[index]['isSelected'] = true;
        setArchivedSelectedMessages([...ArchivedSelectedMessages, messageID + ""]);

      }

      setArchivedMessages(modal);

    }

    else if (type === 'UnArchived') {

      let modal = [...NonArchivedMessagesData];
      const isMessageExist = NonArchivedSelectedMessages?.some((PatientMessageID) => PatientMessageID == messageID);

      if (isMessageExist) {

        modal[index]['isSelected'] = false;
        let filteredData = NonArchivedSelectedMessages?.filter((PatientMessageID) => PatientMessageID != messageID);
        setNonArchivedSelectedMessages(filteredData);

      } else if (!isMessageExist) {

        modal[index]['isSelected'] = true;
        setNonArchivedSelectedMessages([...NonArchivedSelectedMessages, messageID + ""]);

      }


      setNonArchivedMessages(modal);

    }

  }

  const handleOnChange = (e) => {

    const modal = { ...mainMessageModal };

    const { files } = e.target;
    const file = files[0];

    setFileName(file.name)
    modal['FileName'] = file.name;
    const fileType = file.type
    setFileType(fileType)
    if (fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg') {
      const reader = new FileReader();
      reader.onloadend = (event) => {
        modal['FilePath'] = event.target.result.split("base64,")[1];
        setFileInput(event.target.result.split("base64,")[1]);
      };
      reader.readAsDataURL(file);
    } else {
      const reader = new FileReader();
      reader.onloadend = (event) => {
        modal['FilePath'] = event.target.result.split("base64,")[1];
        setFileInput(event.target.result.split("base64,")[1])
      };
      reader.readAsDataURL(file);
    }

    setMainMessageModal(modal);

  }

  const handleOnChangeDescription = (e) => {
    const { name, value } = e.target
    let modal = { ...messageDescriptionModal }
    modal[name] = value;
    setMessageDescriptionModal(modal);
  }

  const handleOnChangeMessage = (e) => {
    const { name, value } = e.target

  }

  const handleOpenThread = (messageID) => {

    const saveModal = {
      "ID": messageID + '',
      "TableName": enumUtil.enumAPITableName.PatientMessageDetail,
    }
    setIsLoading(true);
    setSelectedItem(messageID)
    ServerRequestProtected(API_URL_PatientMessages + '/GetPatientMessages', 'post', saveModal)
      .then((response) => {
        let RowsData = response?.Rows ?? [];
        setIsLoading(false);
        setPatientMessageThread(RowsData);
        setPatientMessageID(messageID);
      })
      .catch((error) => {
        setIsLoading(false);
      })
  }

  const handleSelectAll = (type) => {

    if (type === 'Archived') {

      let nonSelectedMessagesIDs = ArchivedMessagesData?.filter((item) => {
        return !ArchivedSelectedMessages?.some((msgID) => msgID == item?.PatientMessageID)
      })?.map((item) => item?.PatientMessageID)

      if (nonSelectedMessagesIDs?.length > 0) {

        let selectedData = ArchivedMessagesData?.map((item) => {
          return { ...item, isSelected: true }
        })

        setArchivedMessages(selectedData);
        setArchivedSelectedMessages([...SelectedMessages, ...nonSelectedMessagesIDs]);

      } else {
        let selectedData = ArchivedMessagesData?.map((item) => {
          return { ...item, isSelected: false }
        })

        setArchivedMessages(selectedData);
        setArchivedSelectedMessages([]);
      }
    } else if (type === 'NonArchived') {

      let nonSelectedMessagesIDs = NonArchivedMessagesData?.filter((item) => {
        return !NonArchivedSelectedMessages?.some((msgID) => msgID == item?.PatientMessageID)
      })?.map((item) => item?.PatientMessageID)

      if (nonSelectedMessagesIDs?.length > 0) {

        let selectedData = NonArchivedMessagesData?.map((item) => {
          return { ...item, isSelected: true }
        })

        setNonArchivedMessages(selectedData);
        setNonArchivedSelectedMessages([...SelectedMessages, ...nonSelectedMessagesIDs]);

      } else {
        let selectedData = NonArchivedMessagesData?.map((item) => {
          return { ...item, isSelected: false }
        })

        setNonArchivedMessages(selectedData);
        setNonArchivedSelectedMessages([]);

      }

    }


  }

  const handleMessageSelectable = (isSelectable) => {

    setIsMessageSelectable(isSelectable);

  }

  const handleDeleteMessages = (ID, Modal) => {
    setIsDeleteMessage(true);
    setDeleteMessageID(ID);
    setDeleteModal(Modal);

  }

  const onCloseDelete = () => {
    setIsDeleteMessage(false);
    setDeleteMessageID(null)
  }

  const onCloseAfterDelete = () => {
    setIsDeleteMessage(false);
    setDeleteMessageID(null);
    LoadData(searchParam);
  }

  let DeleteMessagesConfirmation = ""
  if (isDeleteMessage) {
    DeleteMessagesConfirmation = <DeleteConfirmatiom isOpenAlert={isDeleteMessage} onCloseDelete={onCloseAfterDelete} API_URL={API_URL_GENERAL} TableName={enumUtil.enumAPITableName.PatientMessage} type={'PatientMessages'} payload={DeleteModal} onClose={onCloseDelete} Messsage={true} hideReason={true} />
  }

  const handleOpenMessages = () => {
    if (IsEditAllowed) {
      setNewMessageOpen(true);
    }
  }

  const onClose = () => {
    setNewMessageOpen(false);
  }

  const onCloseSave = () => {
    setNewMessageOpen(false);
    LoadData(searchParam)
  }

  let MessagePopup = "";
  if (NewMessageOpen) {
    MessagePopup = <AddNewMessage isOpenPopup={NewMessageOpen} ID={PatientIDR} onClose={onClose} onCloseSave={onCloseSave} />
  }

  const ViewPdf = (data) => {
    setFilePreview(null);
    setFilePreviewType(null);
    setIsLoading(true)

    ServerRequestPublic(API_URL_Wasabi_Download, 'post', {
      "BucketPath": data.FilePath
    }, 'Download').then((response) => {
      setIsLoading(false)

      if (response.type === 'application/txt') {
        const blob = response;
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result;
          setFilePreview(content);
          setFilePreviewType('txt');
        };

        reader.readAsText(blob, 'utf-8');
      } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/tiff') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        setFilePreview(objectURL);
        setFilePreviewType('img');
      }
      else if (response.type === 'application/pdf') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        setFilePreview(objectURL);
        setFilePreviewType('pdf');
      }
      else {
        let type = String(response.type).split('/');
        let file = new Blob([response]);
        const fileUrl = URL.createObjectURL(file);
        setFilePreview(fileUrl)
        setFilePreviewType(type?.[1]);
      }
      setPreviewModalActive(true)
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }

  const onCloseFilePreview = () => {
    setPreviewModalActive(false);
  }


  let FilePreviewer = "";
  if (PreviewModalActive) {
    FilePreviewer = <FileViewer isOpenPopup={PreviewModalActive} onClose={onCloseFilePreview} file={FilePreview} type={FilePreviewType} />
  }

  const handleSaveThreadMessage = (messageID) => {

    const saveModal = {
      "ID": messageID + '',
      "TableName": enumUtil.enumAPITableName.PatientMessageDetail,
      "Data": {
        "PatientMessageID": PatientMessageID,
        ...messageDescriptionModal,
        ...mainMessageModal,
      }
    }
    setIsLoading(true);
    ServerRequestProtected(API_URL_PatientMessages + '/SavePatientMessageDetail', 'post', saveModal)
      .then((response) => {

        handleOpenThread(PatientMessageID);
        // setIsLoading(false);
        removeFile();
        setMessageDescriptionModal(Description_Modal);
        setMainMessageModal(Message_Modal);

      })
      .catch((error) => {
        setIsLoading(false);
      })

  }

  const handleSubjectChange = () => {

    setSubjectEditable(false);

    let saveModal = {
      "ID": PatientMessageID,
      "TableName": enumUtil.enumAPITableName.PatientMessage,
      "Data": {
        "Subject": MessageSubject,
      }
    }
    setIsLoading(true);
    ServerRequestProtected(API_URL_PatientMessages + "/SavePatientMessage", 'post', saveModal)
      .then((response) => {
        setIsLoading(false);
        handleOpenThread(PatientMessageID);
      }).catch((error) => {
        setIsLoading(false);
      })
  }

  const DownloadFile = (path, filename) => {
    setIsLoading(true);
    ServerRequestPublic(
      API_URL_Wasabi_Download,
      "post",
      {
        BucketPath: path,
      },
      "Download"
    )
      .then((response) => {
        setIsLoading(false);
        // setImageMenu(false)
        let blob = new Blob([response]);
        saveAs(blob, filename);
      })
      .catch((error) => {
        setIsLoading(false);
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      });
  };

  const removeFile = () => {

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setFileInput('');
    setFileName('');
    setFileType('');

  }

  useEffect(() => {
    LoadData(searchParam)
  }, [])


  const endRef = useRef(null);

  useEffect(() => {
    // Scroll to the bottom every time "records" changes
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [PatientMessageThread]);

  return (
    <div className="ar_pateint_messages_screen">
      <div className="row row-half align-items-end m-0 mt-12 mb-2">
        {MessagePopup}
        {FilePreviewer}
        {isLoading ? <Loader /> : null}
        {DeleteMessagesConfirmation}
        <div className="col-md-4 form-rounded">
          <div className="input">
            <div className='input-group hk-input-search'>
              <input type="text" className='form-control'
                placeholder='Search by name or id…'
                value={searchParam.search}
                onChange={e => setSearchParam({ ...searchParam, search: e.target.value })}
                onKeyDown={SearchOnEnter}
              />
              <span className="input-group-text" id="basic-addon2" onClick={() => SearchByParam(searchParam)}>
                <i className="bi bi-search"></i>
              </span>
              {/* <span className="input-group-text" id="basic-addon2">
                <i className="bi bi-x"></i>
              </span> */}
            </div>
          </div>
        </div>

        {/* <div className='input-group hk-input-search'>
              <SuperSearchMultipleServer
                key={reloadSuperSearchPatient}
                id="PatientIDs"
                name="PatientIDs"
                SuperSearchView="DetailedView"
                DetailedView="Patient"
                initialSelectedOptionsInstant={patientValue}
                searchParam={searchParam}
                setSearchParam={setSearchParam}
                tableName={enumUtil.enumAPITableName.Patient}
                controller={API_URL_Patient}
                ApiLink={"/InstantSearchWithDetails"} //api url 
                method='post'  //   api method
                sup_btn='sup_btn-Inp'
                sup_inp='superSearchVisitInp'
              />
              <span className="input-group-text" id="basic-addon2">
                <i className="bi bi-search"></i>
              </span>
              {/* <span className="input-group-text" id="basic-addon2">
                <i className="bi bi-x"></i>
              </span> */}
        {/* </div> */}

        <div className="col-md-3 multipleSearch-rounded">
          <div className='input'>
            <SuperSearchMultipleClient
              key={reloadSuperSearchPatient}
              id="Type"
              name="Type"
              selectedOptionsDisplay='Type'
              initialSelectedValues={[]}
              searchParam={searchParam}
              setSearchParam={setSearchParam}
              options={DropdownData.filter(item => !['-1', -1].includes(item.value))}
              onSelect={handleMUltiSelectedData}
              sup_btn="sup_btn-Inp"
              sup_inp="superSearchVisitInp"
            />
          </div>
        </div>
        <div className="col-md-5 d-flex align-items-end justify-content-between gap-10">
          <div className='btns-group-flex claims_btns flex-nowrap'>
            <div className="br-clr-light br-right-0-5 pe-2" onClick={() => LoadData(searchParam)}>
              {/* <button className={IsEditAllowed ? 'btn btn-orange btn-xs no-width rounded' : 'btn btn-orange btn-xs no-width rounded disabled'}>Search</button> */}
              <button className={'btn btn-orange btn-xs no-width rounded'}>Search</button>
            </div>
            <div className="br-clr-ligh br-right-0-5t pe-2" onClick={() => clearFilter()}>
              <button className={'btn btn-outline btn-xs no-width rounded'}>Clear</button>
            </div>
            <button className={IsEditAllowed ? 'btn btn-validate rounded w-100 px-10' : 'btn btn-validate rounded w-100 px-10 disabled'} onClick={() => handleOpenMessages()}>New Message</button>
          </div>
        </div>

      </div>
      <div className="row m-0 g-0">
        <div className="col-md-3 ar_sideBar">
          <div className="d-flex flex-column gap-2">
            <p className='heading fs-16 px-10'>PATIENT MESSAGES</p>
            {PatientMessagesData.length > 0 ?
              <div className="d-flex align-items-center justify-content-between px-10">
                <label className='d-flex align-items-center gap-6 user-select-none'>
                  <div className="custom_check_box d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                      checked={showArchived}
                      onChange={handleShowArchivedMessage}
                    />
                  </div>
                  <p className="heading font-m">Show Archived</p>
                  {showArchived ? <p className="heading font-m">({showArchived ? ArchivedMessagesData?.length : NonArchivedMessagesData?.length})</p> : null}
                </label>
                {!IsMessageSelectable ? <p className="heading font-m validate-color cursor-pointer user-select-none" onClick={() => handleMessageSelectable(true)}>Select</p>
                  : <p className="heading font-m validate-color cursor-pointer user-select-none" onClick={() => handleMessageSelectable(false)}>Cancel</p>}
              </div>
              : null}

            {IsMessageSelectable ? <div className="d-flex align-items-center justify-content-between px-10 select-archived">
              <p className="heading font-m validate-color cursor-pointer user-select-none" onClick={() => handleSelectAll(showArchived ? 'Archived' : 'NonArchived')}>Select All</p>

              {showArchived ?
                ArchivedSelectedMessages.length > 0 ?
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <button className=' btn btn-validate px-2 rounded' onClick={() => handleArchivedMessage(ArchivedSelectedMessages, false)}>UnArchive</button>
                    <button className=' btn btn-danger px-2 rounded' onClick={() => handleDeleteMessage(ArchivedSelectedMessages)}>Delete</button>
                  </div> : null
                :
                NonArchivedSelectedMessages.length > 0 ?
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <button className=' btn btn-validate px-2 rounded' onClick={() => handleArchivedMessage(NonArchivedSelectedMessages, true)}>Archive</button>
                    <button className=' btn btn-danger px-2 rounded' onClick={() => handleDeleteMessage(NonArchivedSelectedMessages)}>Delete</button>
                  </div> : null}

            </div> : null}
            <div className="scroll-content px-10 d-flex flex-column gap-2 hover-scrollbar">
              {showArchived ? ArchivedMessagesData?.map((item, index) => {

                return (
                  <div className="d-flex align-items-center gap-2">
                    {IsMessageSelectable ?
                      <div className="custom_check_box d-flex">
                        <input
                          type="checkbox"
                          className="form-check-input mt-0"
                          checked={item?.isSelected}
                          onChange={() => handleSelectedMessage(item?.PatientMessageID, index, 'Archived')}
                        />
                      </div> : null}
                    <div className="ar_content_box icon-hover w-100">
                      <div className={`${selectedItem === item?.PatientMessageID ? "active" : ""} user-select-none`}>
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <div className="d-flex align-items-center gap-6">
                            <p className={`heading fs-13 lh-14`} onClick={() => handleOpenThread(item?.PatientMessageID)}>{item?.Subject}</p>
                            <div className="d-flex align-items-center gap-6 icons">
                              <i class="icon-archive rotate-180 fs-12" onClick={() => handleArchivedMessage(item?.PatientMessageID, false)} ></i>
                              <i class="icon-delete fs-11 text-danger" onClick={() => handleDeleteMessage(item?.PatientMessageID)}></i>
                            </div>
                          </div>
                          <p className='text fs-10 light-clrs lh-11'>{getRelativeDate(item?.CreatedDate, item?.CreatedTime)}</p>
                        </div>

                        <p className='text multiline-ellipsis lh-16'>{getPlainText(item?.Message)} </p>


                      </div>
                    </div>
                  </div>
                )
              }) :
                NonArchivedMessagesData?.map((item, index) => {

                  return (
                    <div className="d-flex align-items-center gap-2">
                      {IsMessageSelectable ?
                        <div className="custom_check_box d-flex">
                          <input
                            type="checkbox"
                            checked={item?.isSelected}
                            className="form-check-input mt-0"
                            onChange={() => handleSelectedMessage(item?.PatientMessageID, index, 'UnArchived')}
                          />
                        </div> : null}
                      <div className="ar_content_box icon-hover w-100" >
                        <div className={`${selectedItem === item?.PatientMessageID ? "active" : ""} user-select-none`}>
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <div className="d-flex align-items-center gap-6">
                              <p className='heading fs-13 lh-14 cursor-pointer' onClick={() => handleOpenThread(item?.PatientMessageID)}>{item?.Subject}</p>
                              <div className="d-flex align-items-center gap-6 icons">
                                <i class="icon-archive fs-12" onClick={() => handleArchivedMessage(item?.PatientMessageID, true)}></i>
                                <i class={IsDeleteAllowed ? "icon-delete fs-11 text-danger" : "icon-delete fs-11 text-danger disabled"} onClick={() => handleDeleteMessage(item?.PatientMessageID)}></i>
                              </div>
                            </div>
                            <p className='text fs-10 light-clrs lh-11'>{getRelativeDate(item?.CreatedDate, item?.CreatedTime)}</p>
                          </div>

                          <p className='text multiline-ellipsis lh-16'>{getPlainText(item?.Message)} </p>
                          {/* {item?.FileName ?
                            <label className="d-flex align-items-center gap-5 attch-file px-2 w-max-content text-nowrap cursor-pointer mt-1 w-100" htmlFor="FileName">
                              <p className="text text-wrap singleLine-ellispis lh-15">{item?.FileName}</p>
                              <div className="ps-10 d-flex align-items-center gap-2">
                                <button className="border-0 bg-transparent no-width rounded eye app_tooltip left p-0" onClick={() => ViewPdf(item)}>
                                  <i className="icon-Icon-awesome-eye fs-10"></i>
                                </button>
                                <button className="border-0 no-width Sdownload-btn" onClick={() => DownloadFile(item?.FilePath, item?.FileName)}>
                                  <i className="icon-download-svgrepo-com fs-16"></i>
                                </button>
                              </div>
                            </label>
                            : null} */}
                        </div>
                      </div>
                    </div>
                  )
                })}

              {/* <div className="d-flex align-items-center gap-2">
                {IsMessageSelectable ?
                  <div className="custom_check_box d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                    />
                  </div> : null}
                <div className="ar_content_box icon-hover">
                  <div className="user-select-none">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <div className="d-flex align-items-center gap-6">
                        <p className='heading fs-13 lh-14'>Non-urgent clinical message</p>
                        <div className="d-flex align-items-center gap-6 icons">
                          <i class="icon-archive fs-12"></i>
                          <i class="icon-delete fs-11 text-danger"></i>
                        </div>
                      </div>
                      <p className='text fs-10 light-clrs lh-11'>Yesterday</p>
                    </div>
                    <p className='text multiline-ellipsis lh-16'>Dear Hazel, Your billing statement for the recent visit is now... </p>
                  </div>
                </div>
              </div> */}
              {(showArchived && ArchivedMessagesData.length === 0 ?
                <div className='d-flex gap-8 align-items-center justify-content-center h-100 flex-column'>
                  <DragIcon />
                  <p className='text fs-11 font-m validate-color user-select-none'>No Messages to be Displayed</p>
                </div>
                : !showArchived && NonArchivedMessagesData.length === 0) ?
                <div className='d-flex gap-8 align-items-center justify-content-center h-100 flex-column'>
                  <DragIcon />
                  <p className='text fs-11 font-m validate-color user-select-none'>No Messages to be Displayed</p>
                </div>
                : null
              }

            </div>
          </div>
        </div>
        <div className="col-md-9 ar_dtailed-content d-flex flex-column gap-10">
          {/* No Message case  */}


          {PatientMessageThread.length > 0 ?
            <div className='messages-section d-flex flex-column gap-10 '>
              {PatientMessageThread?.map((message) => {
                return (
                  <>
                    <div className='default_message icon-hover mx-2'>
                      <div className="d-flex align-items-center justify-content-between">
                        <p class="heading fs-13"><span className='font-m'>To: </span>
                          {/* {message?.PatientName} */}
                          {message.MessageFrom === 'Provider' ? message?.PatientName : 'You'}
                          <span class="font-m ps-2px fs-12 ar-light-color">{`${message?.DOB} ${message?.Age ? `( ${message?.Age} )` : ''} ${message?.Gender}`}</span></p>
                        <div className="d-flex align-items-center gap-6 icons">
                          {message?.IsArcheive === "true" ? <i class="icon-archive rotate-180 fs-12 " onClick={() => handleArchivedMessage(message?.PatientMessageID, false)}></i>
                            :
                            <i class="icon-archive fs-14" onClick={() => handleArchivedMessage(message?.PatientMessageID, true)} ></i>}

                          <i class="icon-delete fs-13 text-danger" onClick={() => handleDeleteMessage(message?.PatientMessageID)}></i>
                        </div>
                      </div>
                      <div className="mt-2 za_br_light br-bottom-1 pb-2">
                        {
                          SubjectEditable
                            ?
                            <div className="w-65 d-flex align-items-center gap-2">
                              <div className="input mb-0 w-100">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Subject"
                                  id="Subject"
                                  value={MessageSubject}
                                  onChange={(e) => setMessageSubject(e.target.value)}
                                />
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <i className='icon-check fs-16 fw-600' onClick={() => handleSubjectChange()}></i>
                                <i className='icon-x-cros gray-clr fw-600' onClick={() => { setSubjectEditable(false); setMessageSubject(""); }}> </i>
                              </div>
                            </div>
                            :
                            <div className="d-flex align-items-center gap-1">
                              <p class="text fs-13"><span className='font-m'>Subject: </span>{message?.Subject}</p>
                              <i className='icon-Icon-material-edit fs-12 ar-light-color' onClick={() => { setSubjectEditable(true); setMessageSubject(message?.Subject); }}></i>
                            </div>
                        }
                      </div>
                      <div className="d-flex flex-column gap-2 pt-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <p className='heading'><span className='font-m'>From: </span>
                            {message?.MessageFrom === 'Provider' ? 'You' : message?.PatientName}
                          </p>
                          <div className="d-flex align-items-center gap-2">
                            <p className="text fs-11 ar-light-color">{message?.CreatedDate}</p>
                            <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">{message?.CreatedTime}</p>
                          </div>
                        </div>
                        <p className='text validation_message text-nowrap lh-normal' title={getPlainText(message?.Message)}>{getPlainText(message?.Message)}</p>
                        {console.log("message", message)}
                        {message?.FileName ?
                          <label className="d-flex align-items-center gap-5 attch-file px-2 w-max-content text-nowrap cursor-pointer" htmlFor="FileName">
                            <p className="text text-wrap singleLine-ellispis lh-15">{message?.FileName}</p>
                            <div className="ps-10 d-flex align-items-center gap-2">
                              <button className="border-0 bg-transparent no-width rounded eye app_tooltip left p-0" onClick={() => ViewPdf(message)}>
                                <i className="icon-Icon-awesome-eye fs-10"></i>
                              </button>
                              <button className="border-0 no-width Sdownload-btn" onClick={() => DownloadFile(message?.FilePath, message?.FileName)}>
                                <i className="icon-download-svgrepo-com fs-16"></i>
                              </button>
                            </div>
                          </label>
                          : null}
                      </div>
                    </div>
                    <div className='px-2 scroll-content d-flex flex-column gap-10 hover-scrollbar'>
                      {message?.Children?.map((item) => {
                        return (
                          <div className="za_br_light br-bottom-1 pb-2 ">
                            <div className="d-flex align-items-center justify-content-between pt-2">
                              <p className='heading'><span className='font-m'>From: </span>{item.MessageFrom === 'Provider' ? 'You' : item.PatientName}</p>
                              <div className="d-flex align-items-center gap-2">
                                <p className="text fs-11 ar-light-color">{item?.CreatedDate}</p>
                                <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">{item?.CreatedTime}</p>
                              </div>
                            </div>
                            <p className='text pt-2'>{getPlainText(item?.Message)}</p>
                            {
                              item?.FileName ?
                                <div className='d-flex position-relative' >
                                  <label className="d-flex align-items-center gap-5 attch-file px-2 w-max-content text-nowrap cursor-pointer" htmlFor='FileName'>
                                    {/* <i className='icon-Icon-metro-attachment fs-12'></i> */}
                                    <p className='text'>{item?.FileName}</p>

                                    <div className="ps-10 d-flex align-items-center gap-2">
                                      <button className="border-0  bg-transparent no-width rounded eye app_tooltip left p-0" onClick={() => ViewPdf(item)}>
                                        <i className="icon-Icon-awesome-eye fs-10"></i>
                                      </button>
                                      <button className="border-0 no-width Sdownload-btn" onClick={() => DownloadFile(item?.FilePath, item?.FileName)}>
                                        <i className="icon-download-svgrepo-com fs-16"></i>
                                      </button>
                                    </div>

                                  </label>

                                </div> : <div></div>
                            }
                          </div>

                        )
                      })
                      }
                      <div ref={endRef} style={{ height: 0 }} />
                    </div>
                    {/* <div className="za_br_light br-bottom-1 pb-2">
                  <div className="d-flex align-items-center justify-content-between pt-2">
                    <p className='heading'><span className='font-m'>From:</span> <span className='validate-color'>PATIENT</span></p>
                    <div className="d-flex align-items-center gap-2">
                      <p className="text fs-11 ar-light-color">8/19/2024</p>
                      <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">4:05 PM</p>
                    </div>
                  </div>
                  <p className='text pt-2'>Alright.</p>
                </div> */}
                  </>
                )
              })
                // <>
                //   <div className='default_message icon-hover'>
                //     <div className="d-flex align-items-center justify-content-between">
                //       <p class="heading fs -13"><span className='font-m'>To:</span> SUGA VIVIAN <span class="font-m ps-2px fs-12 ar-light-color">04/08/2025 (33  Y) Male</span></p>
                //       <div className="d-flex align-items-center gap-6 icons">
                //         <i class="icon-archive fs-14"></i>
                //         <i class="icon-delete fs-13 text-danger"></i>
                //       </div>
                //     </div>
                //     <div className="mt-2 za_br_light br-bottom-1 pb-2">
                //       <div className="d-flex align-items-center gap-1">
                //         <p class="text fs-13"><span className='font-m'>Subject: </span>Non-urgent clinical message</p>
                //         <i className='icon-Icon-material-edit fs-12 ar-light-color'></i>
                //       </div>
                //       {/* <div className="w-65 d-flex align-items-center gap-2">
                //     <div className="input mb-0 w-100">
                //       <input
                //         type="text"
                //         className="form-control"
                //         name="Subject"
                //         id="Subject"
                //       />
                //     </div>
                //     <div className="d-flex align-items-center gap-2">
                //       <i className='icon-check fs-16 fw-600'></i>
                //       <i className='icon-x-cros gray-clr fw-600'> </i>
                //     </div>
                //   </div> */}
                //     </div>
                //     <div className="d-flex align-items-center justify-content-between pt-2">
                //       <p className='heading'><span className='font-m'>From:</span> CHRISSY, BRIGHT</p>
                //       <div className="d-flex align-items-center gap-2">
                //         <p className="text fs-11 ar-light-color">8/19/2024</p>
                //         <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">4:05 PM</p>
                //       </div>
                //     </div>
                //     <p className='text pt-2'>Dear Hazel, <br /> Your billing statement for the recent visit is now available. Please review it at your earliest convenience. Contact us if you need any clarification</p>
                //   </div>
                //   <div className="za_br_light br-bottom-1 pb-2">
                //     <div className="d-flex align-items-center justify-content-between pt-2">
                //       <p className='heading'><span className='font-m'>From:</span> CHRIS</p>
                //       <div className="d-flex align-items-center gap-2">
                //         <p className="text fs-11 ar-light-color">8/19/2024</p>
                //         <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">4:05 PM</p>
                //       </div>
                //     </div>
                //     <p className='text pt-2'>Dear Hazel, <br /> Your billing statement for the recent visit is now available. Please review it at your earliest convenience. Contact us if you need any clarification</p>
                //   </div>
                //   <div className="za_br_light br-bottom-1 pb-2">
                //     <div className="d-flex align-items-center justify-content-between pt-2">
                //       <p className='heading'><span className='font-m'>From:</span> <span className='validate-color'>PATIENT</span></p>
                //       <div className="d-flex align-items-center gap-2">
                //         <p className="text fs-11 ar-light-color">8/19/2024</p>
                //         <p className="ar_dot align-items-center ar_dot d-flex text fs-11 ar-light-color">4:05 PM</p>
                //       </div>
                //     </div>
                //     <p className='text pt-2'>Alright.</p>
                //   </div>
                // </>
              }
            </div>
            :
            <>
              <div className='default_message icon-hover'>
                <div className='empty-data w-40 mb-2'></div>
                <div className='empty-data w-40'></div>
              </div>
              <div className='d-flex align-items-center justify-content-center h-100'>
                <p className='text fst-italic fs-13 ar-light-color'>No Message Selected</p>
              </div>
            </>
          }
          {PatientMessageThread.length > 0 ?
            <div className="px-2 d-flex flex-column gap-10">
              {/* <p className="text text-center user-select-none fst-italic">This thread was archived on 5/14/2025 by Israh, I. <span className='validate-color cursor-pointer text-decoration-underline'>Click to UnArchive.</span></p> */}
              <div class="ar_encounter_main_screen">
                <div class="encounter_detail">
                  <div class="ar-encounter-detail-content">
                    <TextEditor value={messageDescriptionModal?.Message} setValue={value => handleOnChangeDescription({ target: { name: "Message", value } })} />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between gap-30">
                {!isNull(FileName) ?
                  <div className='d-flex align-items-center gap-2 overflow-auto w-100 hover-scrollbar'>
                    <div className="px-10 py-1 d-flex align-items-center gap-10 upload-file-preview">
                      <p className='text'>{FileName}</p>
                      <i className="icon-x-cros fs-15 dark-clr fw-600" onClick={() => removeFile()}></i>
                    </div>
                  </div> : <div></div>
                }
                <div className="d-flex align-items-center gap-2">
                  <div className='d-flex position-relative'>
                    <input
                      type="file"
                      id='FileName'
                      name="FileName"
                      className='d-block opacity-0 position-absolute w-100'
                      accept=".pdf, .xls, .xlsx, .jpg, .jpeg, .png"
                      onChange={handleOnChange}
                      ref={fileInputRef}
                    />
                    <label className="d-flex align-items-center gap-5 attch-file px-2 w-max-content text-nowrap cursor-pointer" htmlFor='FileName'>
                      <i className='icon-Icon-metro-attachment fs-12'></i>
                      <p className='heading dark-clr font-m'>Attach Files</p>
                    </label>
                  </div>
                  <div className="">
                    <button className='btn btn-validate rounded text-nowrap px-10' onClick={() => handleSaveThreadMessage(ThreadMessageID)}>Send Message</button>
                  </div>
                </div>
              </div>
            </div>
            : null}
        </div>
      </div>
    </div>
  )
}

export default PatientMessages
